import { COLORS } from "../ui/colors";

/**
 * Determines the ammo indicator color based on ammo levels.
 * - red = 0 ammo
 * - orange = < half ammo
 * - yellow = >= half ammo but not full
 * - green = full ammo
 */
export function getAmmoColor(currentAmmo: number, maxAmmo: number): string {
  if (currentAmmo === 0) {
    return COLORS.RED; // No ammo
  }

  const ammoPercent = maxAmmo > 0 ? currentAmmo / maxAmmo : 1;

  if (ammoPercent < 0.5) {
    return COLORS.ORANGE; // Less than half ammo
  } else if (ammoPercent < 1.0) {
    return COLORS.YELLOW; // Half to full ammo
  }

  return COLORS.GREEN; // Full ammo
}
